// Formats a whole number of seconds as HH:MM:SS, the same as the labels the
// server renders first (e.g. GameSession.duration_label).
const pad = (value) => String(value).padStart(2, '0')

export const formatHms = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
}
